import type { ReviewItem } from '@/types/api';

import { LayoutReviewsContent } from '../../_layouts/LayoutsReviewsContent';
import LeftContentSection from './LeftContentSection';
import RightContentSection from './RightContentSection';

const ReviewsContent = ({
  review,
  allMarketsQueries,
}: {
  review: ReviewItem;
  allMarketsQueries: any;
}) => {
  // 상태 판별
  const isAnswered = review.ReviewCommentList && review.ReviewCommentList.length > 0;
  const isUnanswerable = !review.IsMarketCommentEnable;
  const hasImage = review.AttachmentList && review.AttachmentList.length > 0;

  return (
    <LayoutReviewsContent>
      {/* LeftSection */}
      <LeftContentSection review={review} />
      {/* Right Section */}
      {/* 3. 답변/상태/입력 */}
      {/* {!isUnanswerable && ( */}
      <RightContentSection review={review} allMarketsQueries={allMarketsQueries} />
      {/* )} */}
    </LayoutReviewsContent>
  );
};

export default ReviewsContent;
